const __DEV__ = false;

var data = { borderRadius:{ values:{ xs:"1px",
      s:"2px",
      m:"4px",
      l:"6px",
      xl:"20px",
      circle:"50%",
      pill:"999999px" } } };

var shape = data;

export { shape as default };
//# sourceMappingURL=shape.yaml.js.map
